import React, { Component } from 'react';
interface State {
  hasError: boolean;
  error: Error | null;
}
interface Props {
  children: React.ReactNode;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('App error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen bg-slate-900 text-white flex flex-col items-center justify-center px-6 text-center" data-id="element-59">
          <h1 className="text-3xl font-bold mb-4" data-id="element-60">
            Ocurrió un error al cargar la página
          </h1>
          <p className="text-slate-300 mb-6 max-w-md" data-id="element-61">
            Por favor, recargá la página. Si el problema persiste, contactanos
            para asistirte.
          </p>
          <button onClick={() => window.location.reload()} className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 px-6 rounded-xl transition-colors" data-id="element-62">
            Recargar
          </button>
        </div>;
    }
    return this.props.children;
  }
}